import { Injectable, OnInit } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { Constants } from '../constants/constants.service';
import { DataService } from '../utils/data/data.service';
import { Session } from '../session/session.service';

@Injectable()
export class CodigosService implements OnInit
{
    private authorization : string =
      "";
    constructor(
      private http: HttpClient,
      private session: Session,
      private dataService: DataService
    ){
      this.authorization += session.idToken;
    }

    ngOnInit(){}
    listar(datos, callback){
      var formData: FormData;
      formData = this.dataService.createFormData(datos);
      formData.append('accessToken', this.session.currentUser.accessToken);

      this.http
      .post(
        Constants.API_BASE + "/codigos/listar",
        formData,
        { withCredentials: true }
      )
      .subscribe(data => {
        callback(data);
      });
    }

    crear(datos, callback){
      var formData: FormData;
      formData = this.dataService.createFormData(datos);
      formData.append('accessToken', this.session.currentUser.accessToken);

      this.http
      .post(
        Constants.API_BASE + "/codigos/crear",
        formData,
        { withCredentials: true }
      )
      .subscribe(data => {
        callback(data);
      });
    }

    editar(datos, callback){
      var formData: FormData;
      formData = this.dataService.createFormData(datos);
      formData.append('accessToken', this.session.currentUser.accessToken);

      this.http
      .post(
        Constants.API_BASE + "/usuarios/editarUsuario",
        formData,
        { withCredentials: true }
      )
      .subscribe(data => {
        callback(data);
      });
    }
    
    asignarTrabajador(datos, callback){
      var formData: FormData;
      formData = this.dataService.createFormData(datos);
      formData.append('accessToken', this.session.currentUser.accessToken);

      this.http
      .post(
        Constants.API_BASE + "/codigos/asignarTrabajador",
        formData,
        { withCredentials: true }
      )
      .subscribe(data => {
        callback(data);
      });
    }
    
    detallesPorCodigo(datos, callback){
      var formData: FormData;
      formData = this.dataService.createFormData(datos);

      this.http
      .post(
        Constants.API_BASE + "/codigos/detallesPorCodigo",
        formData,
        { withCredentials: true }
      )
      .subscribe(data => {
        callback(data);
      });
    }

    deshabilitar(datos, callback){
      var formData: FormData;
      formData = this.dataService.createFormData(datos);
      formData.append('accessToken', this.session.currentUser.accessToken);

      this.http
      .post(
        Constants.API_BASE + "/usuarios/deshabilitar",
        formData,
        { withCredentials: true }
      )
      .subscribe(data => {
        callback(data);
      });
    }

    reconfigurarPassword(datos, callback){
      var formData: FormData;
      formData = this.dataService.createFormData(datos);
      formData.append('accessToken', this.session.currentUser.accessToken);

      this.http
      .post(
        Constants.API_BASE + "/usuarios/reconfigurarPassword",
        formData,
        { withCredentials: true }
      )
      .subscribe(data => {
        callback(data);
      });
    }

    habilitar(datos, callback){
      var formData: FormData;
      formData = this.dataService.createFormData(datos);
      formData.append('accessToken', this.session.currentUser.accessToken);

      this.http
      .post(
        Constants.API_BASE + "/usuarios/habilitar",
        formData,
        { withCredentials: true }
      )
      .subscribe(data => {
        callback(data);
      });
    }

    reporteExcel(form){
      form.action= Constants.API_BASE + "/apr/reporteExcel";
      form.elements[0].value = this.session.currentUser.accessToken;
      form.elements[0].name = 'accessToken';
      form.submit();
    }
}



// WEBPACK FOOTER //
// ./src/app/services/codigos/codigos.service.ts